import { useState } from 'react';
import { Button } from 'reactstrap';

const ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789_-!@#$%^&*';

export function generatePassword(length = 16): string {
  const buf = new Uint8Array(length);
  crypto.getRandomValues(buf);
  let out = '';
  for (let i = 0; i < length; i++) out += ALPHABET[buf[i] % ALPHABET.length];
  return out;
}

interface Props { onGenerated: (pw: string) => void; value?: string; }

export function PasswordGenerator({ onGenerated, value }: Props) {
  const [copied, setCopied] = useState(false);

  const generate = () => {
    const pw = generatePassword();
    onGenerated(pw);
    setCopied(false);
    copyTo(pw);
  };

  const copy = () => {
    if (!value) return;
    copyTo(value);
  };

  const copyTo = (pw: string) => {
    void navigator.clipboard
      .writeText(pw)
      .then(() => {
        setCopied(true);
        window.setTimeout(() => setCopied(false), 1500);
      })
      .catch(() => { /* clipboard not granted — silently ignore */ });
  };

  return (
    <>
      <Button
        type="button"
        color="light"
        size="sm"
        onClick={generate}
      >
        Genera
      </Button>
      <Button
        type="button"
        color="light"
        size="sm"
        onClick={copy}
        disabled={!value}
        aria-label="Copia password"
      >
        {copied ? 'Copiata ✓' : 'Copia'}
      </Button>
    </>
  );
}
